import { toPersonFullname } from "./person-fullname";
import { toPersonNameWithInitial } from "./person-name-with-initial";

/**
 * Как показать имя:
 * - `full` — Ахметова Айгуль Ерлановна;
 * - `name` — Ахметова Айгуль, без отчества;
 * - `initials` — Ахметова А.Е.
 */
export type PersonNameFormat = "full" | "name" | "initials";

type PersonNamePart = string | null | undefined;

export function toPersonName(
  format: PersonNameFormat,
  lastName: PersonNamePart,
  firstName: PersonNamePart,
  middleName?: PersonNamePart,
) {
  switch (format) {
    case "full":
      return toPersonFullname(lastName, firstName, middleName);
    case "name":
      return toPersonFullname(lastName, firstName);
    case "initials":
      return toPersonNameWithInitial(lastName, firstName, middleName);
  }
}
